export default __webpack_public_path__ + "static/media/John-Delore.65cf61e3.jpg";